
<div class="container-fluid">
  <div class="card p-2 position-relative">

    <!-- Edit Button -->
    <button
      *ngIf="userData === 'Krisha Shah' || userData === 'Vaishali Nanda'"
      class="edit-btn"
      [class.editing]="editMode"
      (click)="toggleEdit()"
      permission="Counselling Sop"
      [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]">
      {{ editMode ? ' Save' : ' Edit' }}
    </button>


    <!-- Toolbar -->
    <div class="toolbar" *ngIf="editMode">
      <div class="toolbar-group">

        <!-- Formatting -->
        <button class="toolbar-btn" (click)="executeCommand('bold')"><strong>B</strong></button>
        <button class="toolbar-btn" (click)="executeCommand('italic')"><em>I</em></button>
        <button class="toolbar-btn" (click)="executeCommand('underline')"><u>U</u></button>

        <div class="toolbar-divider"></div>

        <!-- Font Size -->
        <select class="toolbar-select" (change)="executeCommand('fontSize', $any($event.target).value)">
          <option value="">Font Size</option>
          <option value="1">Small</option>
          <option value="3">Normal</option>
          <option value="5">Large</option>
          <option value="7">X-Large</option>
        </select>

        <!-- Text Color -->
        <input type="color" class="toolbar-color"
               (change)="executeCommand('foreColor', $any($event.target).value)"/>

        <div class="toolbar-divider"></div>

        <!-- Alignment -->
        <button class="toolbar-btn" (click)="executeCommand('justifyLeft')">
          <i class="fa fa-align-left"></i>
        </button>
        <button class="toolbar-btn" (click)="executeCommand('justifyCenter')">
          <i class="fa fa-align-center"></i>
        </button>
        <button class="toolbar-btn" (click)="executeCommand('justifyRight')">
          <i class="fa fa-align-right"></i>
        </button>

        <div class="toolbar-divider"></div>

        <!-- Lists -->
        <button class="toolbar-btn" (click)="executeCommand('insertUnorderedList')">
          <i class="fa fa-list-ul"></i>
        </button>
        <button class="toolbar-btn" (click)="executeCommand('insertOrderedList')">
          <i class="fa fa-list-ol"></i>
        </button>

        <div class="toolbar-divider"></div>

        <!-- Table -->
        <button class="toolbar-btn" (click)="insertTable()"><i class="fa fa-table"></i> Table</button>
        <button class="toolbar-btn" (click)="addTableRow()"><i class="fa fa-plus"></i> Row</button>
        <button class="toolbar-btn" (click)="addTableColumn()"><i class="fa fa-plus"></i> Col</button>
        <button class="toolbar-btn" (click)="deleteTableRow()"><i class="fa fa-minus"></i> Row</button>
        <button class="toolbar-btn" (click)="deleteTableColumn()"><i class="fa fa-minus"></i> Col</button>
        <button class="toolbar-btn" (click)="deleteTable()"><i class="fa fa-trash"></i> Table</button>

        <button class="toolbar-btn" (click)="insertLink()" title="Insert Link">
          <i class="fa fa-link"></i>
        </button>

      </div>
    </div>


    <!-- Editable Content -->
    <div #contentArea
         [contentEditable]="editMode"
         class="editable-wrapper"
         [class.editing-mode]="editMode">


      <!-- Header INSIDE contentArea -->
      <div class="header-container">
        <div class="sop-header">

          <h1 class="sop-title"
              [contentEditable]="editMode"
              (input)="onTitleChange($event)">
            {{ sopTitle }}
          </h1>

          <img
            [src]="logoSrc"
            class="sop-logo"
            [class.editable-logo]="editMode"
            [style.pointer-events]="editMode ? 'auto' : 'none'"
            (click)="changeLogo()"
            alt="logo"
          />

        </div>
      </div>

      <h3 class="intro">Introduction : </h3>
      <p class="fs-6">
        - Counselling is an integral element of Oncology treatment. The diagnosis of cancer is devastating for patients
        as well as families. The counsellor listens to patients physical, mental and emotional problems that they may be
        facing.
      </p>
      <p class="fs-6">

        - Counselling helps to cope with their difficulties, during and after cancer diagnosis and treatment. It can
        help reduce stress and improve the quality of life.
      </p>
      <p class="fs-6">
        - Counselling Services are provided across all the centres.
      </p>
      <p class="fs-6">
        - Counselling is primarily for parents and children. Individual family sessions and Group sessions are carried
        out across all the centres.
      </p>
      <p class="fs-6">
        - Religious contexts should be avoided during counselling.
      </p>
      <p class="fs-6">
        - Any major concerns with the families that do not fall under the scope of counselling need to be conveyed to
        the Centre Manager through email.
      </p>
      <p class="fs-6">
        - Avoid addressing Family, Marital and Finance issues, if they bring up these topics subtly divert and make them
        focus on the child’s treatment before anything else during their stay in AL.
      </p>

      <hr>

      <div class="container my-4 mb-3">

        <!-- 1. Pre-Baseline Activity -->
        <div class="mb-4">
          <h5 class="fw-bold fs-6">2. Standard Procedure</h5>
          <table class="table table-bordered score-table">
            <thead>
            <tr>
              <th style="width: 50px;">Sr. No</th>
              <th style="width: 450px;">Type of Sessions</th>
              <th style="width: 220px;">No of Sessions</th>
            </tr>
            </thead>

            <tbody>
            <tr>
              <td>1</td>
              <td>Rapport Building and Psychological Baseline Assessment Test (Admission Assessment)</td>
              <td>During Admission - 1 session</td>
            </tr>

            <tr>
              <td>2</td>
              <td>Regular Counselling Sessions</td>
              <td>2 Sessions per month</td>
            </tr>

            <tr>
              <td>3</td>
              <td>Intermediate Assessment</td>
              <td>Every 2 months during their stay</td>
            </tr>

            <tr>
              <td>4</td>
              <td>Discharge Assessment and counselling</td>
              <td>During discharge - 1 session</td>
            </tr>

            <tr>
              <td>5</td>
              <td>Group Sessions</td>
              <td>Minimum 1 session per month for every centre</td>
            </tr>

            <tr>
              <td>6</td>
              <td rowspan="7">
                <strong>Follow-up Session</strong><br><br>

                <strong>A. Pre-Counselling</strong><br>
                The Counsellor speaks with the CM before each session to receive updates of the family
                <br><br>

                <strong>B. Rapport Building</strong><br>
                The counsellor establishes a rapport with the family and creates a bond with them.<br>
                Conduct the session for 40 mins to an hour.<br><br>

                <strong>1st Session with child along with the family (Introduction Session)</strong>
                <br><br>

                <strong>C. Psychological Baseline Assessment</strong>
                <ol>
                  <li>The counsellor carries out a Psychological Baseline Assessment of the caretakers. The test will be
                    carried out on Assessment sheet in MySpace.
                  </li>
                  <li>A baseline assessment helps determine the family’s emotional and psychological state following a
                    cancer diagnosis.
                  </li>
                  <li>Admission Baseline is to be taken within a week of admission.</li>
                  <li>Every family can be on different levels. We must guide the family accordingly so that they can
                    complete the whole treatment with a healthy mindset.
                  </li>
                </ol>
              </td>
              <td rowspan="7">
                <ol>
                  <li>Self-introduction of the Counsellor</li>
                  <li>Brief idea of how counselling works</li>
                  <li>Baseline Psychological Assessment</li>
                  <li>Concluding the session</li>
                </ol>
              </td>
            </tr>

            <!-- Empty rows required to match the visual structure exactly -->
            <tr></tr>
            <tr></tr>
            <tr></tr>
            <tr></tr>
            <tr></tr>
            <tr></tr>
            </tbody>
          </table>
        </div>

        <!-- 2. Rapport Building Sessions -->
        <div class="mb-4">
          <h5 class="fw-bold fs-6">3. Regular Counselling Sessions: </h5>
          <p class="fs-6"> After the Psychological Assessment, interventions are planned and the counselling sessions
            are
            based on them. <br>
            The following topics are covered in Counselling Sessions:</p>

          <div class="mb-4">
            <h5 class="fw-bold" style="font-size: 15px">A. Psycho-education </h5>
            <p class="fs-6">Educating on Hygiene, Sanitation, Healthy Diet, resolving Misconceptions related to Cancer
              and
              the treatment. <br>
              Identify whether the child is more active and stubborn by nature or is it a side effect of the treatment,
              in
              the latter case parents need to be counselled and made aware that this is a normal reaction from the
              medications that are being given to the child.</p>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold" style="font-size: 15px">B. Tools used in Therapy </h5>
            <p class="fs-6">The following tools and techniques can be used for: Anxiety, Depression, Fear, Lack of
              Confidence, Motivation, Self-esteem, Behavioural Issues and Eating Issues.
              Amongst various techniques, the counsellor can use the following REBT and CBT techniques during
              sessions:</p>
            <ul class="fs-6">
              <li>Rationalization</li>
              <li>Journalling</li>
              <li>Desensitization</li>
              <li>Relaxation techniques</li>
              <li>Art, Play therapy</li>
              <li>Meditation</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold" style="font-size: 15px">C. Pointers for Counselling</h5>
            <ul class="fs-6">
              <li>Active Listening (asking questions to understand the issue without over expression of your emotions or
                sympathy)
              </li>
              <li>Paraphrasing (logically summarize the problem and present)</li>
              <li>Questioning to elicit solutions for the problem (do not suggest or give solutions)</li>
              <li>Using Specific counselling techniques/strategies</li>
              <li>Reviewing & clarifying (request the client to state what they have understood and clarify when not
                clear)
              </li>
            </ul>
          </div>
        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">4. Intermediate Psychological Assessment:</h5>
          <p class="fs-6">- An intermediate psychological assessment evaluates the stress the family has experienced
            over
            the past two months and measures the impact counselling has had during that period.</p>
          <p class="fs-6">- The Assessment results are documented on MySpace.</p>
          <p class="fs-6">- The results of the Assessment are auto generated into a graph to overview the progress over
            the
            time.</p>
        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">5. Discharge Counselling</h5>
          <p class="fs-6">The counsellor takes review to the family leaving AL centre about their experience and the
            overall
            impact on the child’s treatment. The discussion is noted down and the report is prepared by the
            counsellor.</p>
          <div class="mb-4">
            <h5 class="fw-bold" style="font-size: 15px">A. Discharge Psychological Assessment:</h5>
            <p class="fs-6">- A Discharge Assessment is conducted when the child gets discharged from the hospital
              before
              leaving for their hometown, guide the parents on how to care for the child after going home in context
              with
              hygiene like how they maintain hygiene and diet here at the centre in a similar way they have to make the
              child their priority and don’t miss any follow ups.</p>
          </div>
        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">6. Palliative counselling </h5>
          <p class="fs-6">The therapist counsels on the following points to manage the stress </p>
          <ul class="fs-6">
            <li>- Explain to the family that the child has undergone a lot and now the child will get free from all that
              discomfort.
            </li>
            <li>- Focus on quality of life and not on quantity of life.</li>
            <li>- Create memories with the child, spend happy moments.</li>
            <li>- Try to provide all things like favourite food or play with the child.</li>
          </ul>
        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">7. Bereavement counselling </h5>
          <p class="fs-6">This covers the 4 main points:</p>
          <ul class="fs-6">
            <li>To accept the reality of the loss.</li>
            <li>To explain that the death is not your fault and to not feel guilty.</li>
            <li>To adjust to life without the deceased.</li>
            <li>To maintain a connection with the deceased while moving on with life by recalling happy moments spent
              with
              the connection.
            </li>
          </ul>
        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">8. Group Sessions</h5>
          <ul class="fs-6">
            <li>- Group sessions to be taken at every centre at least once a month.</li>
            <li>- Duration of the session can be 1 hour consisting of 30 mins of Counsellor explaining the topic in
              creative
              ways, 15 mins of Q & A and Final 5-10 mins to wrap and conclude the session.
            </li>
            <li>- Sessions for Males and Females can be taken separately and or combined, can also prepare a session for
              the
              whole family together. Only children sessions can also be conducted.
            </li>
            <li>- The session report is documented in a specific format in MySpace.</li>
            <li>- The session topic, format and content has to be approved by the Lead Counsellor which is further
              discussed
              with H.O.D before the session.
            </li>
            <li>- Good Touch/Bad Touch sessions should be conducted with caregivers (males and females separately) and
              with
              teens aged 11 and above whenever new families join the centre. All sessions must be properly documented.
            </li>
          </ul>
        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">9. Follow-Up Sessions</h5>
          <ul class="fs-6">
            <li>Follow-up counseling sessions are conducted when families visit a centre for ongoing support, often as
              part
              of a rehabilitation or therapeutic process.
            </li>
            <li>These sessions are designed to assess progress, address any emerging concerns, and provide additional
              guidance as needed.
            </li>
            <li>During the session, the counsellor conducts an assessment and the responses are documented in MySpace.
            </li>
            <li>During the absence of the counsellor, the Centre Manager is responsible for conducting the assessment.
            </li>
          </ul>
        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">10. Reporting</h5>
          <ul class="fs-6">
            <li>1. Counselling Sessions details are filled up in the Individual/ Group Counselling Forms. This data
              reflects, in the Individual Counselling/ Group Counselling sections separately in MySpace.
            </li>
            <li>2. Psychological Baseline Assessment is carried out for Families on admission, at regular intervals and
              during discharge and filled on Myspace. This data is collected in Myspace. This data is further analysed,
              and
              converted into Impact reports monthly and quarterly.
            </li>
            <li>3. Fortnight Counselling sessions are updated every 15th and 30/31st of the month on the “Session Count
              Sheet”.
            </li>
            <li>4.Once every two months, the counsellor should share the beneficiary’s journey, along with any notable
              changes or positive impact of counselling, and provide relevant pictures to the lead counsellor for social
              media posts.
            </li>
          </ul>
        </div>


        <h3 class="fw-bold text-decoration-underline mb-4 fs-3">Annex A: Reports in use</h3>
        <h3 class="fw-bold text-decoration-underline mb-4 fs-5">Monthly Impact Report</h3>

        <table class="table table-bordered score-table">
          <tr class="yellow-border">
            <th class="p-2" style="width: 70%;">Points</th>
            <th class="p-2" style="width: 30%;">Count</th>
          </tr>

          <tr class="yellow-border">
            <td class="p-2">Total Number of Individual Interventions</td>
            <td class="p-2"></td>
          </tr>

          <tr class="yellow-border">
            <td class="p-2">Total Number of Group Interventions</td>
            <td class="p-2"></td>
          </tr>

          <tr class="yellow-border">
            <td class="p-2">Total Number of Psychological Assessments (Admission / Discharge)</td>
            <td class="p-2"></td>
          </tr>

          <!-- Bottom row spanning left cell + blue border under it -->
          <tr>
            <td class="p-2 blue-bottom-border">
              The Pie Graphical representation of the Admission and Discharge Psychological
              Assessment data of a particular month to determine the level of coping abilities and
              the beneficiaries’ mental/emotional well-being.
            </td>
            <td class="p-2 blue-bottom-border"></td>
          </tr>

          <tr>
            <td class="p-2 blue-bottom-border">
              Key Highlights
            </td>
            <td class="p-2 blue-bottom-border"></td>
          </tr>
          <tr>
            <td class="p-2 blue-bottom-border">
              Problems Addressed in Counselling
            </td>
            <td class="p-2 blue-bottom-border"></td>
          </tr>
          <tr>
            <td class="p-2 blue-bottom-border">
              Interventions and Tools Used
            </td>
            <td class="p-2 blue-bottom-border"></td>
          </tr>
          <tr>
            <td class="p-2 blue-bottom-border">
              Group Counselling
            </td>
            <td class="p-2 blue-bottom-border"></td>
          </tr>
          <tr>
            <td class="p-2 blue-bottom-border">
              Photos
            </td>
            <td class="p-2 blue-bottom-border"></td>
          </tr>
        </table>


        <h3 class="fw-bold text-decoration-underline mb-4 fs-5">Quarterly Counseling Impact Report</h3>
        <h5 class="fw-bold fs-6">Highlights of session counts for the past quarter:</h5>


        <table class="table table-bordered score-table">

          <!-- Header Row -->
          <tr class="yellow-border">
            <th class="p-2" style="width: 33%;">Total number of individual sessions</th>
            <th class="p-2" style="width: 34%;">Total number of Psychological Interventions</th>
            <th class="p-2" style="width: 33%;">Total number of group sessions</th>
          </tr>

          <!-- Blue bordered main content row -->
          <tr class="blue-border">
            <td class="p-3" rowspan="8"></td>

            <td class="p-3">
              Key Highlights
            </td>

            <td class="p-3" rowspan="8"></td>
          </tr>

          <tr class="blue-border">
            <td class="p-3">Problems Addressed in Counselling</td>
          </tr>

          <tr class="blue-border">
            <td class="p-3">Interventions and Tools Used</td>
          </tr>

          <tr class="blue-border">
            <td class="p-3">Photos</td>
          </tr>

          <tr class="blue-border">
            <td class="p-3">
              Activities – All the group sessions conducted in the quarter
            </td>
          </tr>

          <tr class="blue-border">
            <td class="p-3">
              Graphs of Admission and Discharge Psychological Assessment in the past quarter
            </td>
          </tr>

          <tr class="blue-border">
            <td class="p-3">Interpretation from the Graph</td>
          </tr>

          <tr class="blue-border">
            <td class="p-3">Families staying with us</td>
          </tr>

        </table>



          <h3 class="fw-bold text-decoration-underline mb-4 fs-3">Annex B: Psychological Baseline Assessment</h3>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">1. Are you experiencing sleeplessness after understanding about your child’s illness and gravity of the situation?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">2. Are you experiencing loss of appetite after knowing that your child has this illness and the treatment that he/she is undergoing?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">3. Are you feeling dizziness/ giddiness/ nausea while performing daily routine activities, due to the thought process involving your child’s illness?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">4. Are you experiencing headache/mental stress due to the thoughts about your child’s illness and the treatment which is underway?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">5. Are you unable to relax/ take proper rest due to the constant thoughts of your child having this illness and the treatment undergoing?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">6. Are you feeling tiredness/ loss of energy/ no strength to perform normal routine task, due to your child’s illness?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">7. Are you experiencing helplessness and unable to cope with the current situation due to the fact that your child has this illness?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">8. Are you having this thought about death/ dying/ sadness cause of the present circumstances involving your child’s illness?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">9. Do you keep thinking that something really bad or worse is going to happen to me and my family, in relation to the illness and treatment of your child?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">10. Do you feel angry/ agitated cause of the circumstances you are involved in at present primarily concerning the health of your child?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">11. Are you undergoing stages of nervousness due to the fact that your child’s treatment is underway and there is always this constant fear of the outcome?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">12. Is it difficult to figure out and understand the changing behavior of your child when he/ she is undergoing the cancer treatment?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">13. Is it difficult to identify and handle the changing food related habits of the Child?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">14. Is it difficult to understand and handle the stubbornness of the child?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">15. Is it difficult to understand and handle the mood swings of your child during this ongoing treatment?  </h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">16. Is it difficult to handle the aggression and violent behavior of your child?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">17. Did you face any problems in adjusting to the Access Life Centre? </h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">18. Do you face awkwardness in asking for help?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">19. Do you find it difficulty in adjusting to the rules, regulations and schedules of the Access Life?  </h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">20. Do you face any miscommunication with others due to the language barrier?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">21. Do you find it difficult to freely speak and seek support from the counsellor?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">22. Do you get thoughts of abandoning/giving up your child’s treatment?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">23. Do you get exhausted with the amount of time you have to give for taking care of your child when undergoing this treatment?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">24. Do you get worried about your child getting secondary infections?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">25. Does the thought of relapse trouble you?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">26. Do you feel anxious about the other kids/ and family members who are left behind in your hometown?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>


          <h3 class="fw-bold text-decoration-underline mb-4 fs-3 mt-2">Annex B: Follow-Up Questionnaire</h3>


          <div class="mb-4">
            <h5 class="fw-bold fs-6">1. Are you finding it difficult to adjust well back at home?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">2. Are you facing any challenges managing your child's mood swings?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">3. Are you facing any challenges managing your child's behaviour?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">4. Are you facing any challenges managing your child's eating habits?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">5. Are you facing any challenges managing your child's sleep?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6"> 6. Is your child experiencing any challenges related to social interactions?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">7. Has your experience of supporting your child’s cancer treatment impacted your own emotional well-being and mental health?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">8. Are you experiencing headaches/mental stress due to thoughts about your child’s illness and the treatment that is still underway?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">9. Do you feel dizzy/giddiness/nausea while performing daily routine activities, due to the thoughts involving your child’s illness and special needs?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">10. Do you feel angry/agitated because of the circumstances you are involved in concerning the health of your child?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">11. Are you worried about preventing your child from getting any secondary infections?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">12. Does the thought of relapse still trouble you?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold fs-6">13. Do you worry about your child’s future?</h5>
            <ul class="fs-6">
              <li>- Yes </li>
              <li>- No</li>
              <li>- Sometimes</li>
            </ul>
          </div>

      </div>

      <input #fileInput type="file" accept="image/*"
             (change)="handleLogoChange($event)"
             style="display:none;"
      />
    </div>
  </div>
</div>














